import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledActionsWrap = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const StyledButton = styled(Button)`
  &&& {
    background: ${COLORS.NORMAL_GRAY};
    color: ${COLORS.WHITE};
    height: 2.125rem;
  }
`;

export const StyledStatusButton = styled(Button)<{ $isActive: boolean }>`
  &&& {
    width: 9.125rem;
    height: 2.25rem;
    ${pickThemeFontStyles('12', '18', 'BOLD')};

    :hover {
      color: ${({ $isActive }) => ($isActive ? COLORS.WHITE : 'inherit')};
    }

    svg {
      width: 1.25rem;
      height: 1.25rem;
      flex-shrink: 0;
      path {
        fill: ${({ $isActive }) => ($isActive ? COLORS.WHITE : COLORS.SOFT_GRAY)};
      }
    }
  }
`;
